import type {ReactElement} from 'react';
import React from 'react';
import {PosterEditingBaseColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-color-panel';
import type {ColorStorage} from '@Components/color-picker-v2';
import {getColorObjectArrayFromFillColor, getRGBAArrayFromColorStorage} from '@Utils/color.util';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTransitionOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromTransitionOfActiveItem';
import {AnimationType} from '@PosterWhiteboard/items/item/item.types';

export function SlideshowBlockTransitionColorPanel(): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const type = useGetKeyFromTransitionOfActiveItem('type');
  const color = useGetKeyFromTransitionOfActiveItem('color');

  if (!activeItem) {
    throw new Error('Active item is undefined in use slideshow transition option');
  }

  if (!activeItem.isSlideshow()) {
    throw new Error(`Expected slideshow item instead got ${activeItem.gitype}`);
  }

  if (!type || !color) {
    return null;
  }

  if (type !== AnimationType.BLOCK) {
    return null;
  }

  const onChangeColor = (updatedColor: ColorStorage[]): void => {
    void activeItem.updateFromObject(
      {
        transition: {
          color: getRGBAArrayFromColorStorage(updatedColor)[0],
        },
      },
      {undoable: false}
    );
  };

  const onChangeColorEnded = (updatedColor: ColorStorage[]): void => {
    void activeItem.updateFromObject({
      transition: {
        color: getRGBAArrayFromColorStorage(updatedColor)[0],
      },
    });
  };
  return (
    <PosterEditingBaseColorPanel
      id="block-transition-color-panel"
      color={getColorObjectArrayFromFillColor([color])}
      onChangeColor={onChangeColor}
      onChangeEnded={onChangeColorEnded}
      isGradientEnabled={false}
    />
  );
}
